/**
 * AppConfig.js - application metadata shared across the app.
 */
export const APP_CONFIG = {
  APP_NAME: 'BKFC',
  APP_VERSION: process.env.REACT_APP_VERSION || '1.0.0',
  SUPPORT_URL: 'https://bareknuckle.zendesk.com/hc/en-us',
  // Account management (plan, cancel, card, payment history, password, delete) lives ONLY here: the
  // bkfc.com page served by bkfc-cms (/accounts/*). The watch site links to it and keeps no copy.
  ACCOUNT_URL: 'https://www.bkfc.com/account',
};

export default { APP_CONFIG };
